<template>
  <div
    class="position-relative mb-4"
    :class="[{ 'input-custom error': v.$error }]"
  >
    <div :class="['text-editor-custom', { error: isValidate }]">
      <label>
        {{ textFloat }}
        <span v-if="isRequired" class="text-danger">*</span>
      </label>
      <editor ref="editor" :value="value" api-key="no-api-key" :init="init" />
    </div>
    <img :src="img" alt="logo-lang" v-if="img" class="logo-lang" />
    <div v-if="v && v.$error">
      <span class="text-error" v-if="v.required == false">{{
        $t("required")
      }}</span>
    </div>
  </div>
</template>

<script>
import Editor from "@tinymce/tinymce-vue";

export default {
  name: "text-editor",
  components: { editor: Editor },
  props: {
    textFloat: {
      required: true,
      type: String
    },
    placeholder: {
      required: true,
      type: String
    },
    required: {
      required: false,
      type: Boolean
    },
    isRequired: {
      required: false,
      type: Boolean
    },
    pattern: {
      required: false,
      type: String
    },
    detail: {
      required: false,
      type: String
    },
    name: {
      required: false,
      type: String
    },
    value: {
      required: false,
      type: String
    },
    isDisplay: {
      required: false,
      type: Boolean
    },
    rows: {
      required: false,
      type: Number
    },
    isValidate: {
      required: false,
      type: Boolean
    },
    maxLength: {
      required: false,
      type: Number
    },
    img: {
      required: false,
      type: String
    },
    v: {
      required: false,
      type: Object
    },
    imgTypeId: {
      required: false,
      type: Number
    },
  },
  data() {
    return {
      init: {
        height: 500,
        init_instance_callback: editor => {
          editor.on("change", e => {
            this.$emit("onDataChange", editor.getContent());
          });
          editor.on("init", e => {
            // e.target.editorCommand("DB-HeaventRounded-Regular", false, "Arial");
          });
        },
        plugins: [
          "print preview paste importcss searchreplace autolink save directionality code visualblocks visualchars fullscreen image link media template codesample table charmap hr pagebreak nonbreaking anchor toc insertdatetime advlist lists wordcount imagetools textpattern noneditable help charmap quickbars emoticons"
        ],
        menubar: "file edit view insert format table help",
        toolbar:
          "bold italic underline strikethrough | fontselect fontsizeselect formatselect | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist | forecolor backcolor removeformat | pagebreak | charmap emoticons | fullscreen  preview save print | insertfile image media template link anchor codesample | ltr rtl",
        toolbar_sticky: true,
        toolbar_mode: "sliding",
        font_formats:
          "Andale Mono=andale mono,times; Arial=arial,helvetica,sans-serif; Arial Black=arial black,avant garde; Book Antiqua=book antiqua,palatino; Comic Sans MS=comic sans ms,sans-serif; Courier New=courier new,courier; DB HeaventRounded=DB HeaventRounded; Georgia=georgia,palatino; Helvetica=helvetica; Impact=impact,chicago; Kanit=kanit; Symbol=symbol; Tahoma=tahoma,arial,helvetica,sans-serif; Terminal=terminal,monaco; Times New Roman=times new roman,times; Trebuchet MS=trebuchet ms,geneva; Verdana=verdana,geneva; Webdings=webdings; Wingdings=wingdings,zapf dingbats;",
        content_css: "/css/tinymcefont.css",
        quickbars_selection_toolbar:
          "bold italic | quicklink h2 h3 blockquote quickimage quicktable",
        image_caption: true,
        fontsize_formats:
          "8pt 9pt 10pt 11pt 12pt 14pt 18pt 24pt 30pt 36pt 48pt 60pt 72pt 96pt",
        templates: [
          {
            title: "New Table",
            description: "creates a new table",
            content:
              '<div class="mceTmpl"><table width="98%%"  border="0" cellspacing="0" cellpadding="0"><tr><th scope="col"> </th><th scope="col"> </th></tr><tr><td> </td><td> </td></tr></table></div>'
          },
          {
            title: "Starting my story",
            description: "A cure for writers block",
            content: "Once upon a time..."
          },
          {
            title: "New list with dates",
            description: "New List with dates",
            content:
              '<div class="mceTmpl"><span class="cdate">cdate</span><br /><span class="mdate">mdate</span><h2>My List</h2><ul><li></li><li></li></ul></div>'
          }
        ],
        template_cdate_format: "[Date Created (CDATE): %m/%d/%Y : %H:%M:%S]",
        template_mdate_format: "[Date Modified (MDATE): %m/%d/%Y : %H:%M:%S]",
        image_class_list: [{ title: "Responsive", value: "img-responsive" }],
        images_upload_handler: async (blobInfo, success, failure, progress) => {
          if (blobInfo.blob().size / 1024 / 1024 > 5) {
            failure(this.$t("requireTinyUploadImg"), { remove: true });
            return;
          }
          var body = {
            base64: "data:image/jpeg;base64," + blobInfo.base64(),
            type: this.imgTypeId || 0
          };
          var config = {
            onUploadProgress: progressEvent => {
              progress((progressEvent.loaded / progressEvent.total) * 100);
            }
          };
          let data = await this.$callApi(
            "post",
            `${this.$baseUrl}/api/image/save`,
            null,
            this.$headers,
            body
          );

          if (data.url != "") {
            success(data.detail.url);
          } else {
            failure(this.$t("uploadFail"), { remove: true });
          }
        }
      }
    };
  },
  methods: {
    onDataChange(val) {
      this.$emit("onDataChange", val);
    }
  }
};
</script>

<style scoped>
.text-editor-custom {
  color: #16274a;
  font-size: 16px;
  margin-bottom: 2px;
  font-weight: bold;
}
.text-editor-custom.error {
  border: 2px solid red !important;
}
.text-error {
  color: red;
}
</style>
